module.exports = __webpack_public_path__ + "static/img/Round-22-2015.cb32c92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-22-2015.jpg
// module id = jr8d
// module chunks = 0